/**
 * CanvasRegressionCurveRow — `canvas.regression-curve` renderer.
 * Paints the kernel-smoothed curve produced by
 * `RegressionIndex.regression.curve` for a `(number, series)` source.
 */
import type { Option } from "../../core/option.ts";
import { Json } from "../../core/json.ts";
import { RendererRow } from "./renderer-row.ts";

/** The `canvas.regression-curve` painter row: draws a series' kernel-smoothed regression curve. */
export class CanvasRegressionCurveRow extends RendererRow {
  get seriesKey(): string {
    return Json.string(this.attrs(), "key") ?? "default";
  }

  get color(): Option<string> {
    return Json.string(this.attrs(), "color");
  }

  get strokeWidth(): number {
    return Json.number(this.attrs(), "strokeWidth") ?? 2;
  }
}
